export default ({ app, store }) => {
    app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
        const globalSettings = store.getters['global/globalSettings']
        const projectCurrency = globalSettings?.project_currency || 'MDL' // by defualt using 'MDL' currency
        store.dispatch('global/setCurrencyLocalization', projectCurrency)
    }
}